import {gql} from "apollo-angular";
import {basePageableGraphqlField, baseResponse} from "src/app/store/base.graphql";

export const formResponseProcessingStatus = `
id
uniqueId
status
otherFields
files
isLatest
createdAt
`

export const trackingInfo = `
        submitted
        submittedAt
        isActive
        createdAt
        status
`;

export const relayInfo = `
        relayStatus
        relayResponse
        relayRetryCount
        trackNumber
`;

export const formResponseFields = `
    id
    uniqueId
    responsePayload
    serviceUniqueId
    userUniqueId
    companyUniqueId
    form {
      id
      uniqueId
      name
      description
      service {
        id
        serviceUniqueId
        serviceName
        serviceDescription
        serviceCode
        serviceCategory {
          categoryName
          categoryCode
        }
      }
      configuration
      isActive
      isPublished
      createdAt
      formApiHtmlBody
      formApiDetails {
        id
        formApiUniqueId
        formApiDescription
        formRequiresAuth
        formApiAuthType
        formApiKey
        formJwtToken
        formClientId
        formClientSecret
        formApiUrl
      }
    }
    latestProcessingStatus {
      ${formResponseProcessingStatus}
    }
    processingHistory {
      ${formResponseProcessingStatus}
    }
    trackingInfo {
        ${trackingInfo}
      }
    relayInfo {
        ${relayInfo}
      }
`;


export const formResponseFewFields = `
    id
    uniqueId
    userUniqueId
    form {
      id
      uniqueId
      name
      description
      isActive
      isPublished
      createdAt
      service {
        serviceName
        serviceCategory {
          categoryName
        }
      }
    }
    processingHistory {
      status
      otherFields
    }
    trackingInfo {
        status
      }
    relayInfo {
        trackNumber
      }
`;

export const CITIZEN_GET_FORM_RESPONSES = gql`
    query CitizenGetFormResponses($filtering: FormResponseFilterInput) {
        citizenGetFormResponses(filtering: $filtering) {
          ${basePageableGraphqlField}
          response {
                ${baseResponse}
            }
            data{
                ${formResponseFields}
            }
        }
    }
`;

export const GET_FORM_RESPONSES = gql`
query GetFormResponses($filtering: FormResponseFilterInputObject) {
  getFormResponses(filtering: $filtering) {
            ${basePageableGraphqlField}
            response {
                ${baseResponse}
            }
            data{
                ${formResponseFields}
            }
        }
    }
`;

export const GET_FORM_RESPONSES_FEW_FIELDS = gql`
  query GetFormResponses($filtering: FormResponseFilterInputObject) {
    getFormResponses(filtering: $filtering) {
      ${basePageableGraphqlField}
      response {
        ${baseResponse}
      }
      data{
        ${formResponseFewFields}
      }
    }
  }
`;


export const CLOSE_SERVICE_REQUEST_MUTATION = gql`
  mutation CloseServiceRequestMutation($input: CloseServiceRequestInputObject!) {
    closeServiceRequestMutation(input: $input) {
      response {
        id
        status
        code
        message
      }
      data {
        id
        uniqueId
        responsePayload
        form {
          id
          uniqueId
          name
          description
          configuration
          isActive
          isPublished
          createdAt
          service {
            id
            serviceUniqueId
            serviceIsSubService
            serviceCode
            serviceName
            serviceIsApproved
            serviceDescription
            serviceHasSubService
            serviceHasCoProviders
            serviceCoProviders {
              id
              coproviderUniqueId
              coproviderCollaborationPurpose
              coproviderInstitution {
                id
                institutionUniqueId
                institutionName
                institutionShortform
                institutionPhysicalAddress
                institutionEmail
                institutionPostcode
                institutionWebsite
                institutionPhones
                institutionMapUrl
                institutionLogo
                institutionType
              }
            }
            serviceHasOpponents
            serviceGroups {
              id
              groupUniqueId
              groupType
            }
            serviceCategory {
              id
              categoryUniqueId
              categoryCode
              categoryName
              categoryDescription
            }
            serviceOpponents {
              id
              opponentUniqueId
              opponentInstitution {
                id
                institutionUniqueId
                institutionName
                institutionShortform
                institutionPhysicalAddress
                institutionEmail
                institutionPostcode
                institutionWebsite
                institutionPhones
                institutionMapUrl
                institutionLogo
                institutionType
              }
            }
            serviceResults {
              id
              resultUniqueId
              resultDescription
            }
            serviceProvider {
              id
              institutionUniqueId
              institutionName
              institutionShortform
              institutionPhysicalAddress
              institutionEmail
              institutionPostcode
              institutionWebsite
              institutionPhones
              institutionMapUrl
              institutionLogo
              institutionType
              institutionMinistry {
                id
                ministryUniqueId
                ministryName
              }
              institutionSector {
                id
                sectorUniqueId
                sectorCode
                sectorName
                sectorIcon
              }
              institutionRegion {
                id
                regionalUniqueId
                reginalName
                reginalPostcode
                napaId
              }
              institutionDistrict {
                id
                districUniqueId
                districName
                districPostcode
                napaId
                districParentRegion {
                  id
                  regionalUniqueId
                  reginalName
                  reginalPostcode
                  napaId
                }
              }
              institutionWard {
                id
                wardUniqueId
                wardName
                wardPostcode
                napaId
                wardParentDistric {
                  id
                  districUniqueId
                  districName
                  districPostcode
                  napaId
                }
              }
              institutionStreet {
                id
                streetUniqueId
                streetName
                streetPostcode
                napaId
                streetParentWard {
                  id
                  wardUniqueId
                  wardName
                  wardPostcode
                  napaId
                }
              }
              institutionFunctions {
                id
                functionUniqueId
                functionDutyName
                functionCreateddate
                functionIsActive
              }
            }
            serviceApprovalStage {
              id
              stageUniqueId
              stageName
              stageIsStarting
              stageIsEnding
              stageDesignation {
                id
                designationUniqueId
                designationShortForm
                designationName
              }
              successorStage {
                id
                uuid
                stageName
              }
            }
            serviceForm {
              id
              hasForm
              formType
            }
            serviceFunctions {
              id
              uniqueId
              function {
                id
                functionUniqueId
                functionDutyName
                functionCreateddate
                functionIsActive
              }
            }
            serviceApprovalRemark
            serviceSentPopsmgg
            serviceIsRejected
            serviceIsReviewed
          }
          formApiHtmlBody
          formApiDetails {
            id
            formApiUniqueId
            formApiDescription
            formRequiresAuth
            formApiAuthType
            formApiKey
            formJwtToken
            formClientId
            formClientSecret
            formApiUrl
            govesbApiCode
          }
          connectedToGovesb
        }
        serviceUniqueId
        userUniqueId
        relayInfo {
          relayStatus
          relayResponse
          relayRetryCount
          trackNumber
        }
        trackingInfo {
          submitted
          submittedAt
          isActive
          createdAt
          status
        }
        latestProcessingStatus {
          id
          uniqueId
          status
          otherFields
          files
          isLatest
          createdAt
        }
        processingHistory {
          id
          uniqueId
          status
          otherFields
          files
          isLatest
          createdAt
        }
      }
    }
  }
`;
